module.exports = __webpack_public_path__ + "img/streetsweeper_stopped.d1b0e0fd.svg";